import { TranslatePipe } from '../filters/translate.pipe';
import { TranslateUnauthenticatedPipe } from '../filters/translate-unauthenticated.pipe';
import { DatePipe } from '@angular/common';
import { CurrencyPipe } from '../filters/currency.pipe';
import { UnreadChatsPipe } from '../filters/unread-chats.pipe';
import { StringBuilderPipe } from '../filters/string-builder.pipe';
import { Injectable, inject } from '@angular/core';
import AngularBroadcastHelperService from './angular-broadcast-helper.service';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class AngularFilterHelperService {
	private translatePipe: TranslatePipe = inject(TranslatePipe);
	private translateUnauthenticatedPipe: TranslateUnauthenticatedPipe = inject(TranslateUnauthenticatedPipe);
	private datePipe: DatePipe = inject(DatePipe);
	private currencyPipe: CurrencyPipe = inject(CurrencyPipe);
	private unreadChatsPipe: UnreadChatsPipe = inject(UnreadChatsPipe);
	private stringBuilderPipe: StringBuilderPipe = inject(StringBuilderPipe);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private config: Config = inject(Config);
	
	translate(input) {
		return this.translatePipe.transform(input);
	}
	
	translateUnauthenticated(input) {
		return this.translateUnauthenticatedPipe.transform(input);
	}

	watchDocumentTitleUnauthenticated(input) {
		document.title = this.translateUnauthenticated(input);
		return this.angularBroadcastHelperService.onRootEvent(
			this.config.getBroadcastConfig().Dictionary.LOADED,
			() => {
				document.title = this.translateUnauthenticated(input);
			}
		);
	}
	
	formatDate(input, format) {
		return this.datePipe.transform(input, format);
	}
	
	currency(input) {
		return this.currencyPipe.transform(input);
	}
	
	filter(input, jsonMatcher) {
		var result: Array<any> = [];
		var firstKey: any = Object.keys(jsonMatcher)[0];
		if (input && input.length > 0) {
			for(var i = 0; i < input.length; i++) {
				if (input[i].hasOwnProperty(firstKey) && input[i][firstKey] === jsonMatcher[firstKey]) {
					result.push(input[i]);
				}
			}
		}
		return result;
	}
	
	unreadChats(input) {
		return this.unreadChatsPipe.transform(input);
	}
	
	stringBuilder(input, args1?, args2?, args3?) {
		return this.stringBuilderPipe.transform(input, args1, args2, args3);
	}
	
}
